export default __webpack_public_path__ + "static/media/logout.940186ce.svg";